"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitVerticalModal = exports.node_arrow_visible = exports.link_text = exports.uncert_link_text = exports.uncert_node_color = exports.afm_default_link = exports.afm_default_node = exports.node_edition = exports.additional_selector = exports.afm_menu_configuration_import_export = exports.afm_edition_menu = exports.processTrade = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyLayout_1 = require("open-sankey/dist/SankeyLayout");
const SankeyTrade_1 = require("./SankeyTrade");
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const SankeyLayout_2 = require("open-sankey/dist/SankeyLayout");
const d3 = __importStar(require("d3"));
const processTrade = (server_data) => {
    if (server_data.trade_sectors) {
        server_data.trade_sectors.forEach(trade_sector => {
            SankeyTrade_1.split_trade(trade_sector, server_data);
        });
    }
    Object.values(server_data.nodes).forEach(n => {
        n.trade_close = true;
        //n.position='relative'
    });
    const scale = d3.scaleLinear()
        .domain([0, +server_data.user_scale])
        .range([0, 100]);
    //if (server_data.nodeTags['Niveau Echanges']) {
    SankeyLayout_1.reorganize_all_input_outputLinksId(server_data.nodes, server_data.links);
    SankeyTrade_1.arrangeTrade(server_data, scale);
    //}
    return 0;
};
exports.processTrade = processTrade;
const afm_edition_menu = (data, set_show_split_trade_dialog, action_type, set_show_reconciliation) => {
    return react_1.default.createElement(react_bootstrap_1.NavDropdown, { id: 'afm', title: "AFM" },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                if (!('Type de noeud' in data.nodeTags)) {
                    data.nodeTags['Type de noeud'] = {
                        group_name: 'Type de noeud',
                        tags: {
                            'produit': {
                                name: 'produit',
                                selected: true,
                                color: '',
                                shape: 'ellipse'
                            },
                            'secteur': {
                                name: 'secteur',
                                selected: true,
                                color: '',
                                shape: 'rect'
                            },
                            'échange': {
                                name: 'échange',
                                selected: true,
                                color: '',
                                shape: 'rect'
                            }
                        },
                        color_map: '',
                        show_legend: false,
                        banner: 'none',
                        activated: true,
                        siblings: []
                    };
                    Object.values(data.nodes).forEach(n => n.tags['Type de noeud'] = ['secteur']);
                }
            } },
            "Cr\u00E9ation \u00E9tiquette secteur produit",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_split_trade_dialog(true) },
            "Individualiser Import/Export",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                action_type.current = 'optim_sankey';
                set_show_reconciliation(true);
            } },
            "Reconciliation (Sankey)",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                action_type.current = 'optim';
                set_show_reconciliation(true);
            } },
            "Reconciliation (Excel)",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                action_type.current = 'check_excel';
                set_show_reconciliation(true);
            } },
            "V\u00E9rification fichier excel",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                action_type.current = 'create_empty_ter';
                set_show_reconciliation(true);
            } },
            "G\u00E9n\u00E9ration de la table emploi ressource",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")));
};
exports.afm_edition_menu = afm_edition_menu;
const afm_menu_configuration_import_export = (data, set_data, nav_item_active, set_nav_item_active, trade_close, set_trade_close) => {
    const scale = d3.scaleLinear()
        .domain([0, +data.user_scale])
        .range([0, 100]);
    return react_1.default.createElement(react_bootstrap_1.Accordion.Item, { id: 'ImportExport', eventKey: "ImportExport", style: { 'display': 'block' }, onClick: evt => {
            if (evt.target.className === 'accordion-button' && nav_item_active === 'ImportExport') {
                set_nav_item_active('');
            }
            else {
                set_nav_item_active('ImportExport');
            }
        } },
        react_1.default.createElement(react_bootstrap_1.Accordion.Header, null,
            "Import-Export ",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")),
        react_1.default.createElement(react_bootstrap_1.Accordion.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: 'checkbox', label: 'Pr\u00E9s du noeud', checked: trade_close, onChange: evt => {
                                Object.values(data.nodes).forEach(n => n.trade_close = evt.target.checked);
                                set_trade_close(evt.target.checked);
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
                                // if (!data.nodeTags['Niveau Echanges']) {
                                //   return
                                // }
                                SankeyTrade_1.arrangeTrade(data, scale);
                                set_data(Object.assign({}, data));
                            } }, "Arranger"))),
                react_1.default.createElement("hr", null),
                trade_close ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "D\u00E9calage horizontal")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: "200", value: data.trade_close_hspace, onChange: evt => {
                                    data.trade_close_hspace = +evt.target.value;
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null, data.trade_close_hspace)),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "D\u00E9calage vertical")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: "200", value: data.trade_close_vspace, onChange: evt => {
                                    data.trade_close_vspace = +evt.target.value;
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null, data.trade_close_vspace)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "D\u00E9calage horizontal")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: "400", value: data.trade_hspace, onChange: evt => {
                                    data.trade_hspace = +evt.target.value;
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null, data.trade_hspace)),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position du point de controle source")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: "100", value: data.trade_left_shift * 100, onChange: evt => {
                                    const trade_left_shift = (+evt.target.value) / 100;
                                    if (trade_left_shift < data.trade_right_shift) {
                                        data.trade_left_shift = (+evt.target.value) / 100;
                                    }
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null, data.trade_left_shift)),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position du point de controle destination")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: "100", value: data.trade_right_shift * 100, onChange: evt => {
                                    const trade_right_shift = (+evt.target.value) / 100;
                                    if (data.trade_left_shift < trade_right_shift) {
                                        data.trade_right_shift = (+evt.target.value) / 100;
                                    }
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null, data.trade_right_shift)),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Ecart maximum entre points de controle")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: "50", value: data.trade_max_shift * 100, onChange: evt => {
                                    data.trade_max_shift = (+evt.target.value) / 100;
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null, data.trade_max_shift)))))));
};
exports.afm_menu_configuration_import_export = afm_menu_configuration_import_export;
const additional_selector = (data, set_data, units) => {
    const has_natural_unit = false;
    return react_1.default.createElement(react_bootstrap_1.Col, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, null, Array.isArray(units) ? (react_1.default.createElement(react_1.default.Fragment, null, has_natural_unit ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center' } },
                    react_1.default.createElement("b", null, "Unit\u00E9s"))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { color: 'black' }, value: data.display_style.unit ? 'Naturelles' : units.filter(unit => unit !== 'Naturelle')[0], onChange: evt => {
                        const unit = evt.target.value;
                        data.display_style.unit = unit === 'Naturelles';
                        set_data(Object.assign({}, data));
                    } }, units.map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))))) : react_1.default.createElement(react_bootstrap_1.Col, null,
            react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center', fontSize: '20px' } },
                "Unit\u00E9:   ",
                react_1.default.createElement("b", null, units[0]))))) : (react_1.default.createElement(react_bootstrap_1.Col, null))));
};
exports.additional_selector = additional_selector;
const node_edition = (data, set_data, selected_node, trade_width, set_trade_width) => {
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "exchanges", title: "Echanges" },
        react_1.default.createElement("br", null),
        react_1.default.createElement(react_bootstrap_1.Form, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: 'checkbox', label: 'Pr\u00E9s du noeud', checked: selected_node.current.trade_close, onChange: evt => {
                            selected_node.current.trade_close = evt.target.checked;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Width")),
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: selected_node.current.trade_width, onChange: evt => set_trade_width(+evt.target.value), onBlur: () => {
                            selected_node.current.trade_width = trade_width;
                            set_data(Object.assign({}, data));
                        } })))));
};
exports.node_edition = node_edition;
const afm_default_node = (initial_sankey_data) => {
    return Object.assign(Object.assign({}, SankeyUtils_1.default_node(initial_sankey_data)), { trade_height: 20, trade_width: 50, trade_close: false });
};
exports.afm_default_node = afm_default_node;
const afm_default_link = (data) => {
    return Object.assign(Object.assign({}, SankeyUtils_1.default_link(data)), { natural_unit: '', conv: [], tooltips: [] });
};
exports.afm_default_link = afm_default_link;
const uncert_node_color = () => {
    return 'grey';
};
exports.uncert_node_color = uncert_node_color;
const uncert_link_text = (data, d, link_value) => {
    const link_info = SankeyUtils_1.getLinkValue(data, d.idLink);
    let unit_name = '';
    let the_link_value = SankeyUtils_1.toPrecision(link_value);
    if (data.display_style.unit) {
        if (d.natural_unit) {
            unit_name = d.natural_unit.replace('k tonnes', 'kt').replace('k tonne', 'kt');
            the_link_value = SankeyUtils_1.toPrecision(link_value * (d.conv ? d.conv[1] : 1));
        }
    }
    if (link_info.extension.maxi === undefined || link_info.extension.mini === undefined || link_info.extension.maxi === null || link_info.extension.mini === null) {
        return the_link_value + unit_name;
    }
    if (data.display_style.unit && d.conv) {
        const mini = Math.round(d.conv[1] * link_info.extension.mini);
        const maxi = Math.round(d.conv[1] * link_info.extension.maxi);
        return '[' + mini + ' ' + maxi + ']' + ' ' + unit_name;
    }
    if (link_info.extension.mini === link_info.extension.maxi) {
        return link_info.extension.mini + ' ' + unit_name;
    }
    return '[' + link_info.extension.mini + ' ' + link_info.extension.maxi + ']' + unit_name;
};
exports.uncert_link_text = uncert_link_text;
const link_text = (data, d, link_value) => {
    const link_values = SankeyUtils_1.getLinkValue(data, d.idLink);
    const display_free_as_dashed = data.show_structure !== 'free_interval' && data.show_structure !== 'free_value';
    if (display_free_as_dashed) {
        // Generale settings: free link value are displayed dashed without text
        const link_value_is_free = link_values.extension.free_mini !== undefined;
        if (link_value_is_free) {
            // Link value is free should be displayed dashed without text
            if (link_values.extension.free_visible) {
                // Link value can be individually set to be displayed normally even if free
            }
            else {
                return;
            }
        }
    }
    const str_display = String(link_values.display_value);
    if (str_display !== '' && !str_display.includes('[')) {
        return str_display;
    }
    if (data.show_structure === 'structure') {
        return;
    }
    let the_link_value = link_values.value;
    if (link_values.value === '') {
        return;
    }
    if (data.show_structure === 'data') {
        if (link_values.extension && link_values.extension.data_value !== undefined) {
            the_link_value = SankeyUtils_1.toPrecision(link_values.extension.data_value);
        }
        else {
            return;
        }
    }
    if (data.show_structure === 'free_interval' && link_values.extension.free_mini !== undefined) {
        const mini = link_values.extension.free_mini;
        const maxi = link_values.extension.free_maxi;
        the_link_value = '[' + SankeyUtils_1.toPrecision(mini) + ',' + SankeyUtils_1.toPrecision(maxi) + ']';
    }
    else if (data.show_structure === 'free_value' && link_values.extension.free_mini !== undefined) {
        the_link_value += '*';
    }
    if (data.display_style.unit && d.conv && d.natural_unit) {
        let unit_coeff = ' ';
        if (data.units_names[0][0].includes('k ')) {
            unit_coeff = ' k ';
        }
        return SankeyUtils_1.toPrecision(the_link_value * d.conv[1]) + unit_coeff + d.natural_unit.replace('tonnes', 't').replace('tonne', 't').replace('bois rond', '');
    }
    else {
        return the_link_value;
    }
};
exports.link_text = link_text;
const node_arrow_visible = (data, n) => {
    if (!n.node_visible) {
        return false;
    }
    if (n.inputLinksId.length === 0) {
        return false;
    }
    if (n.trade_close && n.tags['Type de noeud'] !== undefined && n.tags['Type de noeud'][0] == 'échange' && n.inputLinksId.length > 1) {
        return false;
    }
    if (!data.links[n.inputLinksId[0]].arrow) {
        return false;
    }
    return true;
};
exports.node_arrow_visible = node_arrow_visible;
const SplitVerticalModalPropTypes = {};
// type  SplitVerticalModalTypes = {
//   data : AFMSankeyData,
//   initial_trade_node_names : string[],
//   set_show_split_trade : (show:boolean) => void
// }
const SplitVerticalModal = ({ data, initial_trade_node_names, set_show_split_trade }) => {
    const [trade_node_names, set_trade_node_names] = react_1.useState(initial_trade_node_names);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => set_show_split_trade(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Noeuds Imports Exports")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Select, { multiple: true, onChange: evt => {
                                    const new_trade_nodes = [];
                                    for (let i = 0; i < evt.currentTarget.options.length; i++) {
                                        if (evt.currentTarget.options[i].selected) {
                                            new_trade_nodes.push(evt.currentTarget.options[i].label);
                                        }
                                    }
                                    data.trade_sectors = new_trade_nodes;
                                    set_trade_node_names(new_trade_nodes);
                                } }, Object.values(data.nodes).filter(n => n.tags['Type de noeud'] && n.tags['Type de noeud'][0] == 'échange' && n.name.split('-').length === 2).map((n, i) => react_1.default.createElement("option", { key: i, value: n.name, selected: trade_node_names.includes(n.name) }, n.name)))))))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                    data.trade_sectors.forEach(trade_sector => SankeyTrade_1.split_trade(trade_sector, data));
                    SankeyLayout_2.compute_default_input_outputLinksId(data.nodes, data.links);
                    Object.values(data.nodes).forEach(function (n) {
                        SankeyLayout_2.reorganize_node_inputLinksId(n, data.nodes, data.links);
                        SankeyLayout_2.reorganize_node_outputLinksId(n, data.nodes, data.links);
                    });
                    set_show_split_trade(false);
                } }, "Individualiser"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => set_show_split_trade(false) }, "Annuler"))));
};
exports.SplitVerticalModal = SplitVerticalModal;
exports.SplitVerticalModal.propTypes = SplitVerticalModalPropTypes;
